export const errorTable = {
  401: 'Доступ запрещен или требуется авторизация. Пожалуйста, перепроверьте введенные данные и повторите попытку',
  403: 'У вас нет прав доступа для просмотра страницы. Пожалуйста, обратитесь к менеджеру по работе с партнерами',
  422: 'Ошибка валидации. Перепроверьте введенные данные или обратитесь к менеджеру по работе с партнерами',
} as Record<number, string>;

export const errorReasonTable = {
  getdoc_company_requisites_missing: 'Необходимо заполнить реквизиты компании. Обратитесь к менеджеру по работе с партнерами',
} as Record<string, string>;
